/**
 * @name Advection.js
 * @description 移流を追加する
 */
import * as THREE from "three";
import face_vert from "./shader/face.vert";
import line_vert from "./shader/line.vert";

import advection_frag from "./shader/advection.frag";

class Advection {
    constructor(stage, props) {
        this.renderer = stage.renderer;

        this.scene = new THREE.Scene();
        this.camera = new THREE.Camera();
        
        this.props = props;

        this.uniforms = {
            boundarySpace: {
                value: this.props.cellScale
            },
            px: {
                value: this.props.cellScale
            },
            fboSize: {
                value: this.props.fboSize
            },
            velocity: {
                value: this.props.src.texture
            },
            dt: {
                value: this.props.dt
            },
            isBFECC: {
                value: true
            },
        }

        this.__init();
    }

    /**
     * @name __init
     */
    __init() {
        this.__createPlane();
        this.__createBoundary();
    }

    /**
     * @name __createPlane
     */
    __createPlane() {
        const geo = new THREE.PlaneGeometry(2.0, 2.0);
        const mat = new THREE.RawShaderMaterial({
            vertexShader: face_vert,
            fragmentShader: advection_frag,
            uniforms: this.uniforms
        });
        this.plane = new THREE.Mesh(geo, mat);
        this.scene.add(this.plane);
    }

    /**
     * @name __createBoundary
     */
    __createBoundary() {
        const geo = new THREE.BufferGeometry();
        const vertices_boundary = new Float32Array([
            // left
            -1, -1, 0,
            -1, 1, 0,

            // top
            -1, 1, 0,
            1, 1, 0,

            // right
            1, 1, 0,
            1, -1, 0,

            // bottom
            1, -1, 0,
            -1, -1, 0
        ]);
        geo.setAttribute('position', new THREE.BufferAttribute(vertices_boundary, 3));

        const mat = new THREE.RawShaderMaterial({
            vertexShader: line_vert,
            fragmentShader: advection_frag,
            uniforms: this.uniforms
        });

        this.line = new THREE.LineSegments(geo, mat);
        this.scene.add(this.line);
    }

    /**
     * @name __raf
     * @param {Object} dt - delta time
     * @param {Boolean} isBounce - バウンドするかどうか
     * @param {Boolean} BFECC - BFECCを使うかどうか
     */
    __raf({ dt, isBounce, BFECC }) {
        this.uniforms.dt.value = dt;
        this.line.visible = isBounce;
        this.uniforms.isBFECC.value = BFECC;

        this.renderer.setRenderTarget(this.props.dst);
        this.renderer.render(this.scene, this.camera);
        this.renderer.setRenderTarget(null);
    }
}

export default Advection;